const productDetail = {
  title: ({ product: { brand, productName, color, productVersionId } }) => {
    if (!color) {
      return `${brand} ${productName} - ${productVersionId} | italist`;
    }
    return `${brand} ${productName} - ${color} - ${productVersionId} | italist`;
  },
  description: () =>
    'Buy it now at italist and save up to 30%. EXPRESS international shipping! Similar products also available',
};

export default productDetail;
